<template>
  <!-- <transition name="fade" mode="out-in"> -->
    <div class="about-page-container">
      <nav-component :isDarkBg="true"></nav-component>
      <div class="about-hero">
        <h2>About</h2>
      </div>
      <div class="about-body">
        <div class="what-we-do">
          <img class="fade-left in-view-trans" src="@/assets/img/what-we-do.jpg" alt />
          <div class="copy">
            <h2>What We Do</h2>
            <p
              class="charcoal"
            >We make it easy to delight your customers and employees with the coolest rewards on the planet. CarltonOne is a cloud-based reward management system – with local and global fulfillment capabilities – that enables your business to increase the performance of recognition programs, sales programs, customer loyalty programs, employee engagement programs, marketing campaigns, and contests. We source and consolidate rewards from hundreds of suppliers around the globe and present them in a beautifully designed, easy-to-use interface.</p>
          </div>
        </div>
        <div class="our-story">
          <div class="copy">
            <h2>Our Story</h2>
            <p
              class="charcoal"
            >CarltonOne is the world’s first cloud-based solution that connects hundreds of global suppliers through an innovative reward engine to thousands of customers around the world. By consolidating a vast network of global suppliers into a single dashboard, we have automated reward data and order fulfillment, enabling our clients to choose from millions of reward options in 190+ countries.</p>

            <p
              class="charcoal"
            >By combining our expertise and strategic thinking with cloud technology, we rewrote the rules for retail loyalty and channel incentive programs and transformed reward management and fulfillment. Today, CarltonOne is the recognized pioneer in the incentives and rewards industry.</p>

            <p
              class="charcoal"
            >We deliver locally-sourced merchandise to 190+ countries and convenient virtual rewards almost anywhere in the world. Our innovative rewards dashboard makes it easy to create customized client galleries and track order status. CarltonOne supplies a worldwide community of recognition, incentives, training, and reward experts in North America, South America, Africa, UK, Europe, Middle East, Asia, India, and Australia. We are also the only reward platform that follows all global tax compliance regulations, making it easier than ever to implement and manage your program.</p>
          </div>
          <div class="img-stack">
            <img
              class="fade-right with-transition-delay in-view-trans"
              src="@/assets/img/our-story1.jpg"
              alt
            />
            <img class="fade-right in-view-trans" src="@/assets/img/our-story2.jpg" alt />
          </div>
        </div>
      </div>
      <div class="working">
        <div class="working-container">
          <div class="icon">
            <img src="@/assets/img/working-icon.png" alt />
          </div>
          <div class="working-copy">
            <h2>Working At CarltonOne</h2>
            <p>At CarltonOne we believe the success of our employees is tied with the success of our business. We hire the smartest and most enthusiastic employees and we keep them by giving them awesome perks and support.</p>
            <a href="https://www.carltonone.com/careers" target="_blank">
              <button class="learn-more-btn">VIEW OPENINGS</button>
            </a>
          </div>
        </div>
      </div>
      <footer-component></footer-component>
    </div>
  <!-- </transition> -->
</template>

<script>
export default {
  data: function () {
    return {
      name: 'about'
    }
  },
  methods: {
    leadershipButton () {}
  }
}
</script>

<style>
/*HEADER/HERO*/
.about-hero {
  background-image: url(../assets/img/about-hero.jpg);
  background-position: center;
  -webkit-background-size: contain;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 80px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.about-hero h2 {
  margin: 40px 0;
  color: #FFF;
  text-align: center;
  font-size: 48px;
  font-weight: 700;
  line-height: 52px;
}

/*MAIN ABOUT SECTION*/
.about-body {
  padding: 80px 0;
  max-width: 1500px;
  margin: 0 auto;
}

.what-we-do {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.what-we-do img {
  width: 50%;
}
.what-we-do .copy {
  padding: 20px 100px 0 60px;
  width: 50%;
}
.what-we-do .copy h2,
.our-story .copy h2 {
  margin-bottom: 10px;
  color: #343333;
  font-size: 32px;
  font-weight: 700;
  line-height: 43px;
}
.what-we-do .copy p,
.our-story .copy p {
  color: #343333;
  font-size: 18px;
  font-weight: 300;
  line-height: 24px;
}
.what-we-do,
.our-story {
  margin-bottom: 60px;
}

.our-story {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.our-story .copy {
  padding: 20px 60px 0 60px;
}

.img-stack {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
.img-stack img {
  margin-bottom: 20px;
}

/*TEAMS SECTION*/
.global-team {
  background-color: #eee;
  padding: 60px 0;
  text-align: center;
}

.team-bio-container .row {
  margin: 50px 0;
  justify-content: space-around;
}
#leadership p.charcoal {
  padding: 0 40px;
}

.row .bio {
  width: 25%;
}

.bio .avatar {
  width: 210px;
  margin-bottom: 10px;
}
.bio h2 {
  font-size: 22px;
  margin-bottom: -8px;
}
.bio .social-icons img {
  width: 30px;
  margin: 0 5px;
}

/*TABBED NAV*/
/*  .tabs-component ul li,
  .tabs-component-panel { color: #000; }
  .tabs-component ul li a {
    text-decoration: none;
    color: #636466;
  }
  .tabs-component ul li:hover a { color: #fff; }
  .tabs-component {
    width: 80%;
    max-width: 1200px;
    margin: 0 auto;
  }
  .tabs-component ul {
    display: flex;
    flex-direction: row;
    list-style-type: none;
    justify-content: center;
    margin: 0 auto;
    padding: 0 0 10px 0;
    border-bottom: 1px solid #acacac;
  }
  .tabs-component ul li { margin-bottom: 10px; }
  .tabs-component ul li a {
    background-color: #e1e1e1;
    color: #636466;
    font-size: 18px;
    font-weight: 300;
    padding: 10px 20px;
    margin: 0 4px;
    transition: all 0.125s linear;
    cursor: pointer;
  }
  .tabs-component ul li a:hover {
    background-color: #00b1ff;
    color: #fff;
  }
  .tabs-component ul li.is-active a {
    background-color: #00b1ff;
    color: #fff;
  }
  .tabs-component ul li.is-active a { color: #fff; }*/

/*WORKING AT GRS*/
.working {
  padding: 60px 0;
  width: 80%;
  max-width: 1200px;
  margin: 0 auto;
}
.working-container {
  margin: 0 auto;
  padding: 30px 60px;
  background-color: #343333;
  border-bottom: 10px solid #C2C2C2;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.working-container .icon img {
  width: 180px;
  max-width: none;
}
.working-copy {
  text-align: left;
  width: 60%;
}
.working-copy h2 {
  margin-bottom: 0;
  color: #FFF;
  font-size: 36px;
  font-weight: 700;
  line-height: 52px;
}
.working-copy p {
  margin: 20px 0 25px;
  color: #FFF;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}

@-moz-document url-prefix() {
  .about-hero h2 {
    font-weight: 700 !important;
  }
}

@media (max-width: 1100px) {
  .about-body {
    padding-bottom: 0;
  }
  .our-story {
    text-align: center;
  }
  .img-stack {
    width: 100%;
    margin-top: 15px;
  }
  .about-body p {
    max-width: 650px;
    text-align: left;
    margin: 0 auto;
  }
  .what-we-do,
  .our-story {
    flex-direction: column;
  }
  .what-we-do img {
    width: 90%;
    margin: 0 auto 40px;
  }
  .what-we-do .copy,
  .our-story .copy {
    width: 90%;
    padding: 0;
    margin: 0 auto;
    text-align: center;
  }

  .our-story {
    margin-bottom: 0;
  }
  .our-story .copy h2 {
    margin-bottom: 10px;
  }
  .img-stack img:first-of-type {
    margin-bottom: 40px;
    max-width: 90%;
    object-fit: contain;
  }

  .img-stack img:last-of-type {
    display: none;
  }
}
@media screen and (max-width: 800px) {
  .team-bio-container .row {
    flex-direction: column;
    margin: 0;
  }
  .team-bio-container .row .bio {
    width: 100%;
    margin-bottom: 40px;
  }

  .working-container {
    flex-direction: column;
    padding: 30px 10px;
  }
  .working-container .icon {
    margin-bottom: 30px;
  }

  .working-copy {
    width: 90%;
  }
}
</style>
